if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span, .button-text');
        this.buyNowButton = this.querySelector('[data-buy-now]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        if (this.buyNowButton) {
          this.buyNowButton.addEventListener('click', this.onBuyNowHandler.bind(this));
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.addToCart({ checkout: false });
      }

      onBuyNowHandler(evt) {
        evt.preventDefault();
        this.addToCart({ checkout: true, button: this.buyNowButton });
      }

      addToCart({ checkout = false, button = this.submitButton } = {}) {
        if (button.getAttribute('aria-disabled') === 'true' || button.hasAttribute('disabled')) return;

        this.handleErrorMessage();

        this.setButtonLoading(button, true);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart && !checkout) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (checkout) {
              window.location = window.routes.checkout_url || '/checkout';
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.setButtonLoading(button, false);
          });
      }

      setButtonLoading(button, loading) {
        const spinner = button.querySelector('.loading__spinner');

        if (loading) {
          button.setAttribute('aria-disabled', true);
          button.classList.add('loading');
          if (spinner) spinner.classList.remove('hidden');
          if (this.submitButton !== button) this.submitButton.setAttribute('aria-disabled', true);
          if (this.buyNowButton && this.buyNowButton !== button) {
            this.buyNowButton.setAttribute('aria-disabled', true);
          }
          return;
        }

        button.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
        button.removeAttribute('aria-disabled');
        if (this.submitButton !== button) this.submitButton.removeAttribute('aria-disabled');
        if (this.buyNowButton && this.buyNowButton !== button) {
          this.buyNowButton.removeAttribute('aria-disabled');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (this.buyNowButton) this.buyNowButton.setAttribute('disabled', 'disabled');
          if (text) this.updateButtonLabel(this.submitButton, text);
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.buyNowButton) this.buyNowButton.removeAttribute('disabled');
          this.updateButtonLabel(this.submitButton, window.variantStrings.addToCart);
        }
      }

      updateButtonLabel(button, text) {
        const label = button?.querySelector('.button-text');
        if (!label || !text) return;

        const textNode = Array.from(label.childNodes).find(
          (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
        );
        if (textNode) {
          textNode.textContent = ` ${text} `;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
